<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>
<script>
import { queryUserById } from '@/api/home'
import { WeixinShare } from '@/utils/wx'

export default {

  name: 'App',
  data() {
    return {
      openedTabs: ['PolicyQuery', 'collect']
    }
  },
  computed: {
    getKeepAliveComs() {
      console.log(this.$store.state.routerCache.KEEP_ALIVE_COMS)
      return this.$store.state.routerCache.KEEP_ALIVE_COMS;
    }
  },
  mounted(){
    this.getCompany()
  },
  methods: {
    async getCompany(){
      const {aplus_queue} = window;
      
      try {
        let res = await queryUserById()
        // this.userInfo = res.result || {}
        //如采集用户信息是异步行为，需要先阻止SDK上报，设置BLOCK埋点
        aplus_queue.push({
        action: 'aplus.setMetaInfo',
          arguments: ['_hold', 'BLOCK'] 
        });
        console.log(36,aplus_queue,'_hold:BLOCK')
      WeixinShare.create(res.result)

      //是否指定用作计算umid的id类型，默认为cnaid，目前支持:
        //1. 微信\QQ openid, 字节、百度 anonymousid, 支付宝 alipay_id
        //2. 微信、QQ、字节、百度平台的 unionid
        //3. 业务方自己生成的随机id uuid
        aplus_queue.push({
          action: 'aplus.setMetaInfo',
          arguments: ['openid', res.result.id]
        });

        //设置userid
        aplus_queue.push({
          action: 'aplus.setMetaInfo',
          arguments: ['_user_id', res.result.id] //值为业务自定义的登录账号ID
        })
      } catch {

      } finally{
        // 因为采集用户信息是异步行为，故需要先设置BLOCK，再设置START
        // 设置_hold=START后，事先被block住的日志会携带上用户信息逐条发出
        console.log(60,'_hold:START')
        aplus_queue.push({
          action: 'aplus.setMetaInfo',
          arguments: ['_hold', 'START'] 
        })
      }
    },

  }
}
</script>
<style lang="scss">
</style>
